import { render, staticRenderFns } from "./FileAttachmentSkeleton.vue?vue&type=template&id=0bc2bfaf&"
import script from "./FileAttachmentSkeleton.vue?vue&type=script&lang=js&"
export * from "./FileAttachmentSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc2bfaf')) {
      api.createRecord('0bc2bfaf', component.options)
    } else {
      api.reload('0bc2bfaf', component.options)
    }
    module.hot.accept("./FileAttachmentSkeleton.vue?vue&type=template&id=0bc2bfaf&", function () {
      api.rerender('0bc2bfaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/files/FileAttachmentSkeleton.vue"
export default component.exports